export default __webpack_public_path__ + "static/media/BB_34.a924a63c.png";